// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3zVS0","content":"LoadingAlert_content__lukvA"};